var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Watch, Utils, Components, CustomTypedEvent, Logging, avoidHandler } from '@pacem/pacem-core';
//namespace Pacem.Components.UI {
export var DialogButtons;
(function (DialogButtons) {
    DialogButtons["YesNo"] = "yesno";
    DialogButtons["YesNoCancel"] = "yesnocancel";
    DialogButtons["Ok"] = "ok";
    DialogButtons["OkCancel"] = "okcancel";
})(DialogButtons || (DialogButtons = {}));
export var DialogButton;
(function (DialogButton) {
    DialogButton["Yes"] = "yes";
    DialogButton["No"] = "no";
    DialogButton["Cancel"] = "cancel";
    DialogButton["Ok"] = "ok";
})(DialogButton || (DialogButton = {}));
export const DialogResultEventName = 'commit';
export class DialogResultEvent extends CustomTypedEvent {
    constructor(args) {
        super(DialogResultEventName, args);
    }
}
export class PacemDialogBase extends Components.PacemElement {
    #deferred;
    open(state) {
        const lb = this.lightbox;
        if (!Utils.isNull(this.#deferred)) {
            throw `Dialog already open.`;
        }
        const deferred = this.#deferred = Promise.withResolvers();
        if (this.hide || this.disabled) {
            this.log(Logging.LogLevel.Warn, 'Dialog hidden or disabled, opening forbidden.');
            deferred.reject();
        }
        else {
            this.dispatchEvent(new Event('open'));
            lb.show = true;
            this.state = state;
        }
        return deferred.promise;
    }
    commit(btn, evt) {
        avoidHandler(evt);
        this.log(Logging.LogLevel.Debug, `Committing dialog by clicking '${btn}'.`);
        const state = this.state;
        var drevt = new DialogResultEvent({ button: btn, state: state });
        this.lightbox.show = false;
        this.#deferred.resolve(drevt.detail);
        this.#deferred = null;
        this.dispatchEvent(drevt);
    }
}
__decorate([
    Watch()
], PacemDialogBase.prototype, "state", void 0);
